import request from "@/utils/request";
//1, 需求详情
export function getDemandDetail(data){
    return request({
        url:'/getDemandDetail',
        data:data,
        method:'get'
    })
}

//2, 需求列表
export function getDemands(data){
    return request({
        url:'/getDemands',
        data:data,
        method:'get'
    })
}
//3, 撤销当前用户提交的需求
export function cancelDemand(data){
    return request({
        url:'/web/cancelDemand',
        data:data,
        method:'post'
    })
}
//4, 查询当前用户提交的需求详情
export function getMyDemandDetail(data){
    return request({
        url:'/web/getMyDemandDetail',
        data:data,
        method:'get'
    })
}
//5, 我发布的需求列表
export function getMyDemands(data){
    return request({
        url:'/web/getMyDemands',
        data:data,
        method:'get'
    })
}

//6, 发布需求
export function newDemand(data){
    return request({
        url:'/web/newDemand',
        data:data,
        method:'post'
    })
}
//7, 编辑需求
export function updateDemand(data){
    return request({
        url:'/web/updateDemand',
        data:data,
        method:'post'
    })
}
